var map = {
	"./assets/images/children/timg.png": 1116,
	"./assets/logo.png": 1117,
	"./assets/logo2.png": 1118,
	"./assets/theme-default/images/1.png": 1119,
	"./assets/theme-default/images/admin.png": 1120,
	"./assets/theme-default/images/admin1.png": 1121,
	"./assets/theme-default/images/logo2.png": 1122,
	"./assets/theme-default/images/yxlogo.png": 1123,
	"./assets/theme-default/images/zftlogo.png": 1124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1183;


//////////////////
// WEBPACK FOOTER
// ./src ^.*\.png$
// module id = 1183
// module chunks = 1